"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeight = exports.Title = exports.StyledText = exports.StyledIcon = exports.StyledErrorWrapper = exports.StyledErrorIcon = exports.StyledDiv = exports.StyledButtonLink = exports.StyledButton = exports.ResetPasswordForm = exports.ErrorNotification = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
var _Button = require("../Button");
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ResetPasswordForm = exports.ResetPasswordForm = _styledComponents["default"].form.withConfig({
  displayName: "styles__ResetPasswordForm",
  componentId: "sc-1bw7cj7-0"
})(["", ";", ";height:335px;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 'margin: 0' : 'margin: 15px 100px 15px;';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 'width: 343px' : 'width: 428px;';
});
var Title = exports.Title = _styledComponents["default"].div.withConfig({
  displayName: "styles__Title",
  componentId: "sc-1bw7cj7-1"
})(["text-align:", ";font-size:", ";margin-bottom:", ";color:", ";font-weight:", ";line-height:", ";"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'left' : 'center';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? '20px' : '24px';
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? '15px' : '40px';
}, _palette.commonPalette.txBlack, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile ? '400' : '600';
}, function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? '30px' : '32px';
});
var StyledDiv = exports.StyledDiv = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledDiv",
  componentId: "sc-1bw7cj7-2"
})(["widht:428px;font-size:14px;line-height:20px;margin-bottom:", ";text-align:", ";color:#333330;"], function (_ref8) {
  var margin = _ref8.margin;
  return margin ? margin : '10px';
}, function (_ref9) {
  var alignText = _ref9.alignText;
  return alignText ? alignText : 'left';
});
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button.Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1bw7cj7-3"
})(["width:100%;margin:15px 0 10px 0;"]);
var StyledText = exports.StyledText = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-1bw7cj7-4"
})(["color:", ";margin:10px 0;text-align:", ";font-size:14px;"], _palette.commonPalette.btnGreen, function (_ref10) {
  var alignText = _ref10.alignText;
  return alignText ? alignText : 'center';
});
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({}).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1bw7cj7-5"
})(["width:16px;height:90%;margin-bottom:3px;margin-right:2px;"]);
var ErrorNotification = exports.ErrorNotification = _styledComponents["default"].div.withConfig({
  displayName: "styles__ErrorNotification",
  componentId: "sc-1bw7cj7-6"
})(["color:#f31414;font-size:14px;font-family:lato;padding:10px 2px;"]);
var StyledErrorWrapper = exports.StyledErrorWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledErrorWrapper",
  componentId: "sc-1bw7cj7-7"
})(["display:flex;margin-left:10px;margin-top:5px;"]);
var StyledErrorIcon = exports.StyledErrorIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({}).withConfig({
  displayName: "styles__StyledErrorIcon",
  componentId: "sc-1bw7cj7-8"
})(["width:16px;color:#f31414;display:inline-block;margin-top:7px;"]);
var getHeight = exports.getHeight = function getHeight() {
  return {
    height: '56px',
    padding: '0px 40px 0px 16px'
  };
};
var StyledButtonLink = exports.StyledButtonLink = _styledComponents["default"].a.withConfig({
  displayName: "styles__StyledButtonLink",
  componentId: "sc-1bw7cj7-9"
})(["color:", ";&:hover{color:", ";}"], _palette.commonPalette.btnGreen, _palette.commonPalette.btnGreen);
//# sourceMappingURL=styles.js.map